module.exports = __webpack_public_path__ + "img/location-marker.b7b787a8.svg";